export function renameProperty<T>(array: T[], originalKey: keyof T, newKey: string): any[] {
  return array.map((item) => {
    const { [originalKey]: value, ...rest } = item;

    return {
      ...rest,
      [newKey]: value,
    };
  });
}
